export const HOTEL_RATES_LIST_REQUEST='HOTEL_RATES_LIST_REQUEST'
export const HOTEL_RATES_LIST_SUCCESS='HOTEL_RATES_LIST_SUCCESS'
export const HOTEL_RATES_LIST_FAIL='HOTEL_RATES_LIST_FAIL'

